import React from 'react'
import PropTypes from 'prop-types'

const Checkbox = ({id, type, name, onChange, checked, itemForAll, value, disabled}) => (
  <div className={`checkbox ${disabled && 'disabled'}`} key={id}>
    <input
      type="checkbox"
      id={name}
      onChange={onChange}
      checked={checked}
      typeitem={type}
      name={itemForAll ? 'all': name}
      disabled={disabled}
      />
    <label htmlFor={name}><span>{value}</span></label>
  </div>
)

Checkbox.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  itemForAll: PropTypes.bool,
  onChange: PropTypes.func
}

export default Checkbox